const CONSTANT = require('../shared/constants')
const _has = require('lodash/has')
const _get = require('lodash/get')

/**
 * Get contextualized name of the node we are leaving.
 * @param {*} router The application router object
 * @returns Returns a contextualized string with its name (example: 'la catégorie Cinéma')
 */
const getContextualizedNodeName = (router) => {
  const pageType = document.querySelector('meta[name="navik::pageType"]')
  const pageName = document.querySelector('meta[name="navik::pageName"]')

  if (pageName && pageName !== '' && pageType && pageType !== '') {
    return router.app.$t(`navik.${pageType.content}`, { name: pageName.content })
  } else if (pageType && pageType !== '') {
    return router.app.$t(`navik.${pageType.content}`)
  } else {
    return null
  }
}

/**
 * If there are v-lazy components in the page, returns an array with all of their heights.
 * @returns Returns an array with heights of all v-lazy components.
 */
const getVLazyHeights = () => {
  const lazyNodes = Array.from(document.getElementsByClassName('v-lazy'))
  return lazyNodes.map(element => element.offsetHeight)
}

/**
 * From given node, list indexes of all ancestors up to the node with id 'app'. This list constitues a 'path'.
 * @param {*} element A DOM element.
 * @returns Returns an array of all node ancestors indexes in top to bottom order.
 */
const getPath = (element) => {
  const root = document.getElementById('app')
  const path = []

  while (element !== root) {
    const parent = element.parentElement

    if (!parent) {
      return null
    }

    const children = Array.from(parent.children)
    const nodeIndex = children.indexOf(element)
    path.unshift(nodeIndex)
    element = parent
  }

  return path
}

/**
 * Store various informations about the state of the page (navigation node) the user is leaving. The 'LEAF' types pages are not considered.
 * @param {*} router The application router object.
 * @param {*} to The destination route object.
 * @param {*} from The left route object.
 */
const savePageState = (router, to, from) => {
  // Save state for nodes that are of type ROOT or NODE and it there are navik meta data for the left route.
  if (_has(from, 'meta.navik') && _get(from, 'meta.navik.type', '') !== CONSTANT.NODE_TYPE.LEAF) {
    const focusedElement = document.activeElement

    // Store route fullpath, name, type, scroll position, focus
    const previousNode = {
      ...from.meta.navik,
      fullPath: from.fullPath,
      name: getContextualizedNodeName(router),
      state: {
        scrollPosition: {
          x: window.scrollX,
          y: window.scrollY
        },
        lazyHeights: getVLazyHeights(),
        focus: {
          id: focusedElement.id,
          path: getPath(focusedElement)
        }
      }
    }

    router.app.$root.$store.commit('navik/updateNavigationHistory',
      {
        previousNode,
        nextNode: {
          fullPath: to.fullPath
        },
        mode: _get(to, 'params.navik.navigationMode', CONSTANT.NAVIGATION_MODE.VERTICAL)
      })
  }
}

module.exports = savePageState
